import NamespaceFactory from '@rdfjs/namespace/Factory.js'

export default NamespaceFactory
